var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlZumurudaLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "543.3 545.8 540 408 536.7 545.8 543.3 545.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "677.8 404.7 540 408 677.8 411.3 677.8 404.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "536.7 270.2 540 408 543.3 270.2 536.7 270.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "402.2 411.3 540 408 402.2 404.7 402.2 411.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.8,522.1c0,.5-.2,1.1-.3,1.6h0c-1.3,6.9-2,14-2,21.2h-.9c0,.1-8.4-77.9-8.4-77.9l-6.3-59,8.6,55.3,9.2,58.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M677,393.3l-78,8.4-59,6.3,55.3-8.6,58.8-9.2c.5,0,1.1.2,1.6.3h0c6.9,1.3,13.9,2,21.2,2v.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-8.6-55.3-9.2-58.8c0-.5.2-1.1.3-1.6,1.3-6.9,2-14,2-21.2h.9c0-.1,8.4,77.9,8.4,77.9l6.3,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-55.3,8.6-58.8,9.2c-.5,0-1.1-.2-1.6-.3h0c-6.9-1.3-13.9-2-21.1-2v-.9c-.1,0,77.9-8.4,77.9-8.4l59-6.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566,496.3c-1,2.3-2,4.7-2.9,7.1l-11-45.4-12.1-50,14,47.5,12,40.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.4,384.9l-45.4,11-50,12.1,47.5-14,40.9-12c2.3,1,4.7,2,7.1,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-14-47.5-12-40.8c1-2.3,2-4.7,2.9-7.1l11,45.4,12.1,50.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-47.5,14-40.9,12c-2.3-1-4.7-2-7.1-2.9l45.4-11,50-12.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.1,482.7c-.8,1.3-1.5,2.6-2.3,3.9,0,.2-.2.3-.3.5l-13.7-35.5-16.9-43.7,18.4,41.6,14.7,33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.1,377.4l-35.5,13.7-43.7,16.9,41.6-18.4,33.1-14.7c1.3.8,2.6,1.5,3.9,2.3.2,0,.3.2.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-18.4-41.6-14.7-33.1c.8-1.3,1.5-2.6,2.3-3.9,0-.2.2-.3.3-.5l13.7,35.5,16.9,43.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-41.6,18.4-33.1,14.7c-1.3-.8-2.6-1.5-3.9-2.3-.2,0-.3-.2-.5-.3l35.5-13.7,43.7-16.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.6,473c-.8,1.1-1.6,2.2-2.4,3.3l-16.2-29.8-21-38.5,22.5,36.8,17.1,28.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.3,370.7l-29.8,16.2-38.5,21,36.8-22.5,28.1-17.1c1.1.8,2.2,1.6,3.3,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-22.5-36.8-17.1-28.1c.8-1.1,1.6-2.2,2.4-3.3l16.2,29.8,21,38.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-36.8,22.5-28.1,17.1c-1.1-.8-2.2-1.6-3.3-2.4l29.8-16.2,38.5-21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586,465.1c0,0-.2.2-.3.3-.7.8-1.4,1.7-2.1,2.5l-18.7-25.7-24.9-34.2,26.3,32.6,19.7,24.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.9,364.3l-25.7,18.7-34.2,24.9,32.6-26.3,24.4-19.7c0,0,.2.2.3.3.8.7,1.7,1.4,2.5,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-26.3-32.6-19.7-24.4c0,0,.2-.2.3-.3.7-.8,1.4-1.7,2.1-2.5l18.7,25.7,24.9,34.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-32.6,26.3-24.4,19.7c0,0-.2-.2-.3-.3-.8-.7-1.7-1.4-2.5-2.1l25.7-18.7,34.2-24.9Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M592.6,458.1c-.9.8-1.7,1.7-2.5,2.5l-21.4-22.5-28.7-30.2,30.2,28.7,22.5,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M592.6,357.9l-22.5,21.4-30.2,28.7,28.7-30.2,21.4-22.5c.8.9,1.7,1.7,2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-30.2-28.7-22.5-21.4c.9-.8,1.7-1.7,2.5-2.5l21.4,22.5,28.7,30.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-28.7,30.2-21.4,22.5c-.8-.9-1.7-1.7-2.5-2.5l22.5-21.4,30.2-28.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.9,451.7c-.9.7-1.7,1.4-2.5,2.1,0,0-.2.2-.3.3l-24.4-19.7-32.6-26.3,34.2,24.9,25.7,18.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586,350.9l-19.7,24.4-26.3,32.6,24.9-34.2,18.7-25.7c.7.9,1.4,1.7,2.1,2.5,0,0,.2.2.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-34.2-24.9-25.7-18.7c.9-.7,1.7-1.4,2.5-2.1,0,0,.2-.2.3-.3l24.4,19.7,32.6,26.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-24.9,34.2-18.7,25.7c-.7-.9-1.4-1.7-2.1-2.5,0,0-.2-.2-.3-.3l19.7-24.4,26.3-32.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.3,445.3c-1.1.8-2.2,1.6-3.3,2.4l-28.1-17.1-36.8-22.5,38.5,21,29.8,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M579.6,343l-17.1,28.1-22.5,36.8,21-38.5,16.2-29.8c.8,1.1,1.6,2.2,2.4,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-38.5-21-29.8-16.2c1.1-.8,2.2-1.6,3.3-2.4l28.1,17.1,36.8,22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-21,38.5-16.2,29.8c-.8-1.1-1.6-2.2-2.4-3.3l17.1-28.1,22.5-36.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619.1,438.6c-.2,0-.3.2-.5.3-1.3.7-2.6,1.5-3.9,2.3l-33.1-14.7-41.6-18.4,43.7,16.9,35.5,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.1,333.3l-14.7,33.1-18.4,41.6,16.9-43.7,13.7-35.5c0,.2.2.3.3.5.7,1.3,1.5,2.6,2.3,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-43.7-16.9-35.5-13.7c.2,0,.3-.2.5-.3,1.3-.7,2.6-1.5,3.9-2.3l33.1,14.7,41.6,18.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-16.9,43.7-13.7,35.5c0-.2-.2-.3-.3-.5-.7-1.3-1.5-2.6-2.3-3.9l14.7-33.1,18.4-41.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M635.4,431.1c-2.4.9-4.8,1.8-7.1,2.9l-40.9-12-47.5-14,50,12.1,45.4,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566,319.7l-12,40.9-14,47.5,12.1-50,11-45.4c.9,2.4,1.8,4.8,2.9,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-50.1-12.1-45.4-11c2.4-.9,4.8-1.8,7.1-2.9l40.8,12,47.5,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-12.1,50-11,45.4c-.9-2.4-1.8-4.8-2.9-7.1l12-40.9,14-47.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M677,422.7v.9c-7.3,0-14.4.7-21.3,2h0c-.5,0-1.1.2-1.6.3l-58.8-9.2-55.3-8.6,59,6.3,78,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.8,293.9l-9.2,58.8-8.6,55.3,6.3-59,8.4-78h.9c0,7.3.7,14.4,2,21.3h0c0,.6.2,1.1.3,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-59-6.3-78-8.4v-.9c7.3,0,14.4-.7,21.3-2,.5,0,1.1-.2,1.6-.3l58.8,9.2,55.3,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M540,408l-6.3,59-8.4,78h-.9c0-7.3-.7-14.4-2-21.2h0c0-.6-.2-1.2-.3-1.7l9.2-58.8,8.6-55.3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.5,780.2c0,21.1-14.1,26.5-23.4,26.5-14,0-22.7-6.5-22.7-26.5v-47.1s-8.8,0-8.8,0v47.8c0,21.7,13.2,28.9,28.7,28.9s28.7-8.2,28.7-29.9v-46.8s-2.5,0-2.5,0v47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M537.5,733.1h-2.2l-21.5,62.3-22.6-57.9c-1-2.6-3.6-4.4-6.4-4.4h-9.9v1.4c3,.9,4.3,3.3,4.3,10.5v63.7h2.1s0-62.9,0-70.4l27.8,70.4h2l24.4-71.7v71.7h8.8v-68.7c0-3.8-3.1-6.9-6.9-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.4,780.2c0,21.1-14.1,26.5-23.4,26.5-14,0-22.7-6.5-22.7-26.5v-47.1s-8.8,0-8.8,0v47.8c0,21.7,13.2,28.9,28.7,28.9s28.7-8.2,28.7-29.9v-46.8s-2.5,0-2.5,0v47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M730.3,780.2c0,21.1-14.1,26.5-23.4,26.5-14,0-22.7-6.5-22.7-26.5v-47.1s-8.8,0-8.8,0v47.8c0,21.7,13.2,28.9,28.7,28.9s28.7-8.2,28.7-29.9v-46.8s-2.5,0-2.5,0v47.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M762.2,733.1h-21.5v75.5h24c23.7,0,38.9-14.3,38.9-39.5,0-17.5-11.8-36-41.4-36ZM764.5,806.7h-14.9v-71.6h15c17.5,0,29.2,14.2,29.2,35.7,0,22.6-10.5,35.8-29.4,35.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.2,733.1l2.6,6.6-27.9,68.8v.3c-.1,0,3,0,3,0l11.3-28h30.6s11.7,28,11.7,28h9.4l-31.1-75.6h-9.6ZM227.3,777.9l14-34.7,14.1,34.7h-28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.1,733.1h-9.6l2.6,6.6-27.9,68.8v.3c-.1,0,3,0,3,0l11.3-28h30.6s11.7,28,11.7,28h9.4l-31.1-75.6ZM817.6,777.9l14-34.7,14.1,34.7h-28.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.3,805.3c-5,.6-9.2.9-12.6.9h-8.4v-73.1h-8.8v75.6h47.6v-6.2l-5.2.9c-3.4.6-7.6,1.2-12.6,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M650.6,789.7c-5.8-4.7-9.6-8.5-11.2-11.2,7.8-.8,14-3.3,18.3-7.4,4.4-4.2,6.6-9.8,6.6-16.6s-.4-5.1-1.3-7.5c-.9-2.4-2.2-4.7-4-6.8-1.8-2.1-4.3-3.9-7.5-5.2-3.2-1.3-7-1.9-11.2-1.9h-22.7v75.6h8.9v-30h7.5c1.1,0,2.2,0,3.3-.1,9.2,16.9,17.3,26.9,24.2,29.8h.1c0,0,5.5-8.2,5.5-8.2h-.2c-5-2.2-10.5-5.7-16.5-10.6ZM634.1,776.3h-7.5v-41.4h9.5c3.4,0,6.3.6,8.8,1.9,2.5,1.3,4.5,3,5.9,5.2,1.4,2.2,2.5,4.5,3.2,7,.7,2.5,1.1,5.2,1.1,7.9,0,6.4-1.8,10.7-5.4,14.2-3.6,3.4-8.8,5.2-15.5,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.7,733.1v6.2s5.2-.9,5.2-.9c3.4-.6,7.6-1.2,12.6-1.8,5-.6,9.2-.9,12.6-.9h9.8s-46.5,71.7-46.5,71.7v1.4h0,0s55.8,0,55.8,0v-6.2s-5.2.9-5.2.9c-3.4.6-7.6,1.2-12.6,1.8-5,.6-9.2.9-12.6.9h-14.1s46.8-71.7,46.8-71.7v-1.4h-51.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "331 754.1 334.8 754.1 338.3 733.1 327.6 733.1 331 754.1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.5,630.4c-8.1,0-13.7,1-16.4,3.8-2.9,2.6-2.9,5.7-2.9,13.9h2.2c.7-9.2,6.6-12,14.7-12s18.9,8,18.9,20.4-2.4,11.4-5.2,15.4c-2.8,4-8,6.2-13.5,6.2h-18.4v4.3h20.6c8.5,0,15.3-3,19.9-7.6,4.7-4.7,7.3-11.2,7.3-18.4s-2.6-13.7-7.3-18.5c-4.7-4.7-11.4-7.6-19.9-7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M704,658.1c0,2.4-.2,4.8-.7,7.1-1.1,4.7-2.9,6.8-5,9-2.8,2.8-8.5,4-12.1,4h-87.4v-47.9s-10.7,0-10.7,0v51.9c0,3.5-.4,7.5-1.8,11.6-1.6,4.2-4.4,8.2-9.5,11.2l1.4,1.1c2.8-.7,6.2-2.1,11.2-5.6,4.8-3.4,9.1-8.9,9.3-18h94.4c6.2,0,11.4-2.4,15.4-6.6,4-4.2,6.2-10.1,6.2-17.5v-50.9h-10.7v50.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "730.1 607.5 730.1 682.5 740.8 682.5 740.8 607.6 730.1 607.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M543.9,631.6c-9.5,0-17.7,2.9-22.7,8-6.1,5.5-8.7,12.3-8.7,21.5v2.1c-.5,6.1-1.9,9.9-4.2,12.1-2.2,2.2-5.2,2.9-8.6,2.9h-20.7v-47.9s-10.7,0-10.7,0v51.9c0,3.5-.4,7.5-1.8,11.6-1.6,4.2-4.4,8.2-9.5,11.2l1.4,1.1c2.8-.7,6.2-2.1,11.2-5.6,4.8-3.4,9.1-8.9,9.3-18h25.4c1.7-.2,3.3-.5,4.9-1.1,2.8-.9,5-2.7,6.6-5.7,1.2,2.2,2.8,4.5,4.8,6.6,4.9,4.8,12.5,8.1,21.5,8.1s17.7-2.6,23.2-8c5.5-5,8.5-12.3,8.5-21.3s-2.8-16.1-8.1-21.5c-4.8-4.8-12.8-8.1-21.8-8.1ZM556.7,679.1c-3.1,4.3-7.4,6.4-12.8,6.4s-9.5-2.4-12.8-7.3c-3.3-5-5.4-10.1-5.4-18.9s1.7-12.5,4.7-16.8c3.1-4.2,7.4-6.3,13-6.3s9.5,2.4,12.8,7.5c3.3,4.8,4.7,10.2,4.7,19.1s-.9,12.1-4.2,16.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.4,639.5c-5.3,4.4-9.1,10.5-9.2,17.9.2,7.4,3.9,13.5,9.2,17.9,5.4,4.5,12.4,7.3,19,7.3h26.2v-50.3h-26.2c-6.6,0-13.6,2.8-19,7.3ZM382.8,678.2h-16.5c-10.1,0-16.4-9.2-16.5-20.8.1-11.6,6.3-20.8,16.5-20.8h16.5v41.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.6,622c3.7,0,6.7-3,6.7-6.5s-3-6.7-6.7-6.7-6.5,3-6.5,6.7,3,6.5,6.5,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.3,622c3.7,0,6.5-3,6.5-6.5s-2.8-6.7-6.5-6.7-6.5,3-6.5,6.7,2.8,6.5,6.5,6.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M593.2,622c3.7,0,6.7-3,6.7-6.5s-3-6.7-6.7-6.7-6.5,3-6.5,6.7,3,6.5,6.5,6.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlZumurudaLogoWhite);
export default __webpack_public_path__ + "static/media/AlZumurudaLogoWhite.6074f3398cc0136036df80569cc0c3cf.svg";
export { ForwardRef as ReactComponent };